import { render, staticRenderFns } from "./leadersView.vue?vue&type=template&id=6f96f7bf"
import script from "./leadersView.vue?vue&type=script&lang=js"
export * from "./leadersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports